module.exports = __webpack_public_path__ + "img/7.929fc30b.png";